import { Button } from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";

const CandidateTransferHeader = ({ onOpenModal }) => {
  return (
    <>
      <Button variant={"contained"} color="primary" onClick={onOpenModal} startIcon={<DoubleArrowIcon />} sx={{ height: 40 }}>
        New Transfer
      </Button>
    </>
  );
};

export default CandidateTransferHeader;
